import { render } from "./ubicaciones.vue?vue&type=template&id=068ad869&scoped=true"
import script from "./ubicaciones.vue?vue&type=script&lang=js"
export * from "./ubicaciones.vue?vue&type=script&lang=js"

import "./ubicaciones.vue?vue&type=style&index=0&id=068ad869&scoped=true&lang=css"

import exportComponent from "/home/raulgarcia/Escritorio/projects/Vue/capwashmx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068ad869"]])

export default __exports__